import { Coords } from '../../../../elements/resource/types/shape.type';
import { _screenX, _screenY } from '../../../../services/canvas/canvas.service';
import { BackgroundService } from '../../../store/studio/background/background.service';
import {
  CanvasBackground,
  CanvasBackgroundConfig,
} from '../../canvas-background';
import gsap from 'gsap';

export interface EllipseBackgroundOptions {
  startAngle: 'vertical' | 'horizontal' | '45';
  speed?: number; // default is Math.PI / 8 / sec
  radiusScale: number; // default is 1
  colors: string[];
  gloveRadiusRatio: number;
}

export interface CustomEllipseBackgroundOptions {
  ellipse: Record<
    string,
    {
      color: string;
      alpha: number;
      // center's x-y will be [-2 -> 2, -2 -> 2]
      center: Coords;
      // radius's x-y will be [0 -> 2, 0 -> 2]
      radius: Coords;
    }
  >;
}

export class EllipseBackground extends CanvasBackground {
  constructor(
    bgService: BackgroundService,
    private readonly options: EllipseBackgroundOptions,

    config: CanvasBackgroundConfig = {},
  ) {
    super(bgService, config);
    this.init();
  }

  reset() {
    // -- // -- //
    this.init();
  }

  addToCanvas() {
    this.container.removeChildren();
    console.log('------- ellipse > addToCanvas --------');
    Object.values(this._gloves).forEach(glove => {
      this.container.addChild(glove.sprite);
    });
  }

  init() {
    // -- // -- //
    const {
      startAngle,
      colors,
      gloveRadiusRatio,
      speed = Math.PI / 8,
      radiusScale = 1,
    } = this.options;
    const [cx, cy] = [_screenX / 2, _screenY / 2].map(v => v * radiusScale);

    let angle = 0;

    // -- //
    let angles: number[];
    switch (startAngle) {
      case 'vertical':
        angle = Math.PI / 2;
        break;
      case 'horizontal':
        angle = 0;
        break;
      case '45':
        angle = Math.PI / 4;
        angles = [Math.PI / 4, (5 * Math.PI) / 4];
        break;
    }

    colors.map((color, index) => {
      const angle = angles[index];
      this.initGlove(`${index}`, {
        color,
        alpha: 1,
        center: [
          cx + (Math.cos(angle) * _screenX) / 2,
          cy + (Math.sin(angle) * _screenY) / 2,
        ],
        radius: [
          (_screenX / 4) * gloveRadiusRatio,
          (_screenY / 4) * gloveRadiusRatio,
        ],
      });
    });
  }

  getAngleForTime(time: number) {
    const speed = this.options.speed || Math.PI / 2;
    return Math.PI / 4 + speed * time;
  }

  getCoordsForTime(time: number) {
    // this.bgService.setBackgroundByTime(time);
    // const speed = this.options.speed || Math.PI / 2;
    const speed = Math.PI / 2;
    // -- // -- // -- // -- //
    let angles = [];
    const [cx, cy] = [_screenX / 2, _screenY / 2];

    // -- // -- // -- //
    switch (this.options.startAngle) {
      case 'vertical':
        break;
      case 'horizontal':
        break;
      case '45':
        // -- // -- //
        angles = [Math.PI / 4, (5 * Math.PI) / 4];

        return angles.map(angle => {
          return [
            cx +
              (Math.cos(angle + speed * time) *
                _screenX *
                this.options.radiusScale || 1) /
                2,
            cy +
              (Math.sin(angle + speed * time) *
                _screenY *
                this.options.radiusScale || 1) /
                2,
          ];
        }) as Coords[];
    }
  }

  getCoordsForAngle(angle: number) {
    // -- //
  }

  setStateByTime(time: number) {
    // console.log('set-state-by-time', time);
    const centers = this.getCoordsForTime(time);

    this._gloves['0'].updatePosition(centers[0]);
    this._gloves['1'].updatePosition(centers[1]);
    // -- // -- // -- // -- //
  }

  play(): gsap.core.Timeline {
    const timeLine = gsap.timeline();
    return timeLine;
  }

  _animateFull() {
    const timeLine = gsap.timeline();

    // return gsap.timeline(); /
    return timeLine;
  }

  _animate(start: number, end: number) {
    // -- // -- // -- // -- // -- //
    const timeLine = gsap.timeline();
    // const [glov0, glov1] = this.getCoordsForTime(end);

    const startAngle = this.getAngleForTime(start);
    const endAngle = this.getAngleForTime(end);

    // console.log('animate', { start
    // , end });

    const driver = { time: start };

    timeLine.add(
      gsap.to(driver, {
        duration: end - start,
        time: end,
        // ease: 'power1.inOut',
        ease: 'none',
        onUpdate: () => {
          // console.log('on-update', this.progress());
          // this.bgService.render();
          // console.log('theha', driver.time);
          const centers = this.getCoordsForTime(driver.time);
          (this._gloves['0'].updatePosition(centers[0]),
            this._gloves['1'].updatePosition(centers[1]));
          // this.parent._gloves['1'].updatePosition(centers[1]); //
        },
      }),
      0,
    );
    // timeLine.add(
    //   gsap.to(this._gloves['0'].sprite.position, {
    //     duration: end - start,
    //     x: glov0[0],
    //     y: glov0[1],
    //     // ease: 'power1.inOut',
    //     ease: 'none',
    //     onUpdate: function () {
    //       // console.log('on-update', this.progress());
    //       // this.bgService.render();

    //     },
    //   }),
    //   0,
    // );

    // timeLine.add(
    //   gsap.to(this._gloves['1'].sprite.position, {
    //     duration: end - start,
    //     x: glov1[0],
    //     y: glov1[1],
    //     // ease: 'power1.inOut',
    //     ease: 'none',
    //   }),
    //   0,
    // );

    const _start = performance.now();
    /* timeLine.eventCallback('onComplete', () => {
      console.log('bgService > on-complete', performance.now() - _start);
    }); */

    return timeLine;
  }
}
